import { Button, createStandaloneToast, Text, Tooltip } from '@chakra-ui/react';
import { useReflink } from 'src/providers/Reflink/useReflink';
import { useGameColorsProvider } from 'src/providers/Theme/gameColorsProvider';
import { ActionCopyReflink } from 'src/utils/icons/actionCopyReflink';

export const Reflink = ({ id }: { id: string }) => {
	const reflink = useReflink();
	const { textColor } = useGameColorsProvider();
	const { toast } = createStandaloneToast();

	const handleReferral = async () => {
		await reflink.copyReflink(id);
		toast({ title: `Copied your referral` });
	};

	return (
		<Tooltip
			placement="bottom-end"
			label="Earn 5% for every friend who buys this game"
		>
			<Button
				variant="unstyled"
				display="flex"
				height="auto"
				gridGap="10px"
				alignItems="center"
				onClick={handleReferral}
			>
				<Text
					fontWeight="500"
					fontSize="10px"
					lineHeight="13px"
				>
					Refer and earn
				</Text>
				<ActionCopyReflink color={textColor} />
			</Button>
		</Tooltip>
	);
};
